import { render, staticRenderFns } from "./cq.vue?vue&type=template&id=a12a3034&scoped=true&"
var script = {}
import style0 from "./cq.vue?vue&type=style&index=0&id=a12a3034&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12a3034",
  null
  
)

export default component.exports